import { writeFile, mkdir } from 'fs/promises';
import path from 'path';
import { execFileSync } from 'child_process';
import { generateOpensslConfig } from './generateOpensslConfig.js';
import { getOpensslPath } from './getOpensslPath.js';
import { getCertificatePaths } from './getCertificatePaths.js';
import { getValidDomains } from './getValidDomains.js';

/**
 * Writes a self-signed cert using openssl to the temporary cert paths returned by getCertificatePaths.
 */
export async function createCertificate(options: {
  domain: undefined | string | string[];
  cwd: string;
  passphrase?: string;
}): Promise<{ certFolderPath: string; certPath: string; keyPath: string }> {
  const { domain } = options;
  const domains = getValidDomains(domain);
  const certPaths = getCertificatePaths(options);
  const { certFolderPath, certPath, keyPath } = certPaths;

  console.log(`Generating self-signed cert for "${domains[0]}" in "${certFolderPath}"`);

  const opensslFilePath = getOpensslPath();

  console.info(`The "openssl" binary was found in "${opensslFilePath}"`);

  // Ensure the folder exists.
  await mkdir(certFolderPath, { recursive: true });

  const config = generateOpensslConfig(options);
  const opensslConfigPath = path.join(certFolderPath, `${domains[0]}.cnf`);

  if (config === undefined) {
    throw new Error(`createCertificate: unable to create openssl config.`);
  }

  await writeFile(opensslConfigPath, config, 'utf8');

  const cmdArgs = ['req', '-x509', '-out', certPath, '-keyout', keyPath, '-days', '824', '-config', opensslConfigPath];

  if (process.platform === 'linux' || process.platform === 'darwin') {
    // If -new is not provided openssl will hang expecting input.
    cmdArgs.push('-new');
  }

  console.log(`Running: ${opensslFilePath} ${cmdArgs.join(' ')}`);

  execFileSync(opensslFilePath, cmdArgs, {
    stdio: 'ignore',
  });

  return certPaths;
}
